import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { message } from 'antd';

import Modal from './Modal';
import { patchSurvey } from '../../actions/asyncActions';
import GroupForm from '../forms/survey/GroupForm';

class GroupModal extends Component {
    render() {
        const { modal, params: { variables, item, id, group }, patchSurvey } = this.props;

        return <Modal
            {...modal}
            title={item ? 'Редактировать группу' : 'Добавить группу'}
            footer={null}>
            <GroupForm
                item={item}
                formAction={patchSurvey}
                variables={variables}
                group={group}
                id={id} />
        </Modal>;
    }
}

export default withAsyncActions({
    patchSurvey: patchSurvey
        .withSuccessHandler(({ close }) => {
            message.success('Группа успешно сохранена');
            close();
        })
        .withErrorHandler(() => message.error('Не удалось сохранить группу'))
        .withOptions({ resetOnUnmount: true })
})(GroupModal);
